import InternalStakeholderDefinition from "../model/InternalStakeholderDefinition";

export default class InternalStakeholderAvailabilityEvent {
    /**
     * 
     * @param {string} type 
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    constructor(type, internalStakeholder) {
        this.type = type;
        this.internalStakeholder = internalStakeholder;
    }
}

InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_AVAILABLE = "InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_AVAILABLE";
InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_UNAVAILABLE = "InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_UNAVAILABLE";